
/**
 * Centralized date parsing utilities
 */

// Helper function to parse date string safely (YYYY-MM-DD format)
export const parseDateFromUrl = (dateString: string): Date | null => {
  if (!dateString) return null;
  
  // Split the date string to avoid timezone issues
  const [year, month, day] = dateString.split('-').map(Number);
  if (!year || !month || !day) return null;
  
  // Create date in local timezone (month is 0-indexed)
  const date = new Date(year, month - 1, day);
  const result = isNaN(date.getTime()) ? null : date;
  
  return result;
};

// Parse date string from database maintaining the exact date
export const parseDateFromDatabase = (dateString: string): Date | null => {
  if (!dateString) return null;
  
  // Split the date string to avoid timezone issues
  const [year, month, day] = dateString.split('-').map(Number);
  if (!year || !month || !day) return null;
  
  // Create date in local timezone (month is 0-indexed)
  // This ensures we get exactly the date stored in the database
  const date = new Date(year, month - 1, day);
  const result = isNaN(date.getTime()) ? null : date;
  
  return result;
};

// Convert Date to URL-safe string format (YYYY-MM-DD)
export const formatDateForUrl = (date: Date): string => {
  return date.toISOString().split('T')[0];
};

// Format date for display maintaining exact date
export const formatDateForDisplay = (dateString: string): string => {
  const date = parseDateFromDatabase(dateString);
  if (!date) return dateString;
  
  return formatDateForUrl(date);
};

// Check if a date is valid
export const isValidDate = (date: Date | null | undefined): date is Date => {
  return date instanceof Date && !isNaN(date.getTime());
};

// Normalize date to start of day (remove time component)
export const normalizeDate = (date: Date): Date => {
  const normalized = new Date(date);
  normalized.setHours(0, 0, 0, 0);
  return normalized;
};
